import { memo } from 'react';
import PropTypes from 'prop-types';

import { DatePicker } from 'basic-components';

/* eslint-disable no-unused-vars */
const Date = ({
  value,
  valueType,
  validators,
  onChange,
  size = undefined,
  menuPosition = undefined,
  animationEnded = undefined,
  dependsOnParam = undefined,
  extraGroupQuery = undefined,
  referenceDependsOnParam,
  readableName,
  withProvider,
  ref,
  ...props
}) => (
/* eslint-enable no-unused-vars */
    <DatePicker
        {...props}
        defaultValue={value === undefined || String(value).trim() === "" ? undefined : value}
        errorTooltipDataPlace="left"
        fixed
        isPortal
        onChange={onChange}
        ref={ref}
        zIndex={9999}
    />
  )

Date.displayName = "Date"


Date.propTypes = {
  animationEnded: PropTypes.bool,
  dependsOnParam: PropTypes.object,
  extraGroupQuery: PropTypes.object,
  menuPosition: PropTypes.any,
  onChange: PropTypes.func.isRequired,
  size: PropTypes.string,
  validators: PropTypes.array.isRequired,
  value: PropTypes.any.isRequired,
  valueType: PropTypes.string.isRequired, 
}

export default memo(Date);